module.exports = __webpack_public_path__ + "assets/img/7bf6c3c91a8a4a933930e7c59671250b.png";